module.exports = __webpack_public_path__ + "img/shop-taobao.f49a9855.png";